// extracted by mini-css-extract-plugin
export default {"span-link":"span-link--12c9e3","spanLink":"span-link--12c9e3","span-link_pseudo":"span-link_pseudo--7e067f","spanLink_pseudo":"span-link_pseudo--7e067f"};